<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="48">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
          <router-link :to="{name: 'Components'}" class="subtitle-1 routerLink font-weight-medium">Componentes</router-link> <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon> Signup Forms
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="4" v-if="$store.state.apps.retrieveLoader">
      <v-skeleton-loader type="article" />
    </v-col>
    <template v-else>
      <v-col cols="4" v-for="d in formsList" :key="d.id">
        <v-card class="card-apps" :to="{ name: 'FormDetail', params: { id: d.id } }">
          <v-card-text class="py-6 px-0">
            <v-list class="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <img :src="require(`@/assets/appIcon-apps--SignupForms.svg`)" width="24px">
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">{{d.name}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip class="my-1 mr-1" color="secondary" small v-for="ap in d.available_plans.slice(0, 2)" :key="ap.id">
                      <span>{{ap.plan.name}}</span>
                    </v-chip>
                    <span class="ml-1 py-2" v-if="d.available_plans.length > 2">(+{{d.available_plans.length - 2}} otros)</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="card-apps background" :to="{name: 'FormCreate'}" outlined>
          <v-card-text class="py-13 text-center subtitle-1 primary--text font-weight-medium">Crear un nuevo Signup Form</v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  mixins: [
    ListViewMixin
  ],
  computed: mapState({
    formsList: state => state.apps.formsList
  }),
  methods: {
    getList () {
      this.$store.dispatch('apps/LIST', {
        resource: 'signup_forms/forms'
      })
    }
  }
}
</script>
